<template lang="pug">
  SspLayout(area="core")
    .row.order-roll
      .col-sm-6
        .panel.panel-default
          .panel-heading.panel-title Roll Details
          .panel-body(v-if="roll")
            .container-fluid
              .row
                label.col-sm-6 Description
                .col-sm-6 {{roll.description}}
              .row
                label.col-sm-6 Calibrated
                .col-sm-6 {{roll.calibrated ? 'Yes' : 'No'}}
              span(v-if="roll.calibrated")
                .row
                  label.col-sm-6 First Code
                  .col-sm-6.kzcode-default {{roll.first.code}}
                .row
                  label.col-sm-6 First Unactivated Code
                  .col-sm-6.kzcode-default(v-if="roll.firstUnactivated") {{roll.firstUnactivated.code}}
                .row
                  label.col-sm-6 First Unactivated Code Index
                  .col-sm-6(v-if="roll.firstUnactivated") {{roll.firstUnactivated.codeIndex}}
                .row
                  label.col-sm-6 Last Code
                  .col-sm-6.kzcode-default {{roll.last.code}}
              .row
                label.col-sm-6 Unactivated Codes
                .col-sm-6 {{roll.unactivated}}


      .col-sm-6(v-if="roll && (!roll.calibrated || roll.ascending === true)")
        GenericTable(ref="grid")
          tr(slot="thead")
            th Stretches
              .legend-box.pull-right
              span.pull-right Roll Activated Codes

          tr(v-for="s in roll.stretches")
            td(v-if="s.ascending")
              .first-last-codeindex
                .pt10
                  span.bold {{s.firstCodeIndex}}
                  span.bold.pull-right {{s.lastCodeIndex}}
              .activated-codes(:style="{ width: asecendingActivatedPercent(s.firstCodeIndex, s.lastCodeIndex, s.firstUnactivatedCodeIndex) + '%'}")

            td(v-else-if="!s.ascending")
              .first-last-codeindex
                .pt10
                  span.bold {{s.lastCodeIndex}}
                  span.bold.pull-right {{s.firstCodeIndex}}
              .activated-codes(:style="{width: desecendingActivatedPercent(s.firstCodeIndex, s.lastCodeIndex, s.firstUnactivatedCodeIndex) + '%'}")

      .col-sm-6(v-else-if="roll && roll.ascending === false")
        GenericTable(ref="grid")
          tr(slot="thead")
            th Stretches
              .legend-box.pull-right
              span.pull-right Roll Activated Codes

          tr(v-for="s in roll.stretches")
            td(v-if="s.ascending")
              .first-last-codeindex
                .pt10
                  span.bold {{s.lastCodeIndex}}
                  span.bold.pull-right {{s.firstCodeIndex}}
              .activated-codes(:style="{ width: desecendingActivatedPercent(s.firstCodeIndex, s.lastCodeIndex, s.firstUnactivatedCodeIndex) + '%'}")

            td(v-else-if="!s.ascending")
              .first-last-codeindex
                .pt10
                  span.bold {{s.firstCodeIndex}}
                  span.bold.pull-right {{s.lastCodeIndex}}
              .activated-codes(:style="{width: asecendingActivatedPercent(s.firstCodeIndex, s.lastCodeIndex, s.firstUnactivatedCodeIndex) + '%'}")
</template>

<script>
import Core from '@/service/apis/Core'
import GenericTable from '@/components/common/GenericTable'

export default {
  data: () => ({
    errorMsg: null,
    roll: null
  }),
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      Core.getRollDetails(this.rollId)
        .then((resp) => {
          this.roll = resp.data
          if (this.roll.calibrated === false || this.roll.ascending === true) {
            this.roll.stretches = resp.data.stretches.sort((a, b) => a.sortIndex - b.sortIndex)
          } else {
            this.roll.stretches = resp.data.stretches.sort((a, b) => b.sortIndex - a.sortIndex)
          }
        })
        .catch((e) => {
          this.$emit('error', e)
        })
    },
    asecendingActivatedPercent(first, last, firstUnactivated) {
      if (!firstUnactivated && !this.roll.calibrated) {
        return 0
      }
      const unactivatedCodes = parseInt(last - firstUnactivated, 10)
      const totalCodes = parseInt(last - first, 10)
      return 100 - (100 * (unactivatedCodes / totalCodes)).toFixed(2)
    },
    desecendingActivatedPercent(first, last, firstUnactivated) {
      if (!firstUnactivated && !this.roll.calibrated) {
        return 0
      }
      const totalCodes = parseInt((last - first) + 1, 10)
      const activatedCodes = parseInt(last - firstUnactivated, 10)
      const width = (activatedCodes / totalCodes) * 100
      return width
    }
  },
  computed: {
    rollId() {
      return parseInt(this.$route.params.rollId, 10)
    }
  },
  components: {
    GenericTable
  }
}
</script>

<style lang="scss">
.order-roll {
  table {
    position: relative;
  }
  .legend-box {
    background: #C6C4D2;
    border: 2px solid white;
    height: 15px;
    width: 15px;
    display: inline-block;
  }
  .activated-codes {
    background: #C6C4D2;
    height: 50px;
  }
  .first-last-codeindex {
    position: absolute;
    width: 99%;
  }
  .last-index {
    padding-bottom: 20px;
  }
  tr {
    position: relative;
  }
  td {
    padding: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/core/order/roll/Roll.vue